import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EDealType, EEntityType } from '../../shared/repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { fetchDeleteOfferFromFavorites } from '../../shared/repositories/favorites/v1/delete-offer-from-favorites';
export function removeFavorites(_x) {
  return _removeFavorites.apply(this, arguments);
}
function _removeFavorites() {
  _removeFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var httpApi, logger, params, parameters;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = _ref.httpApi, logger = _ref.logger, params = _ref.params;
          parameters = {
            dealType: EDealType.Sale,
            entityType: EEntityType.OfferResidental,
            entityId: params.offerId
          };
          _context.prev = 2;
          _context.next = 5;
          return fetchDeleteOfferFromFavorites({
            httpApi: httpApi,
            parameters: parameters
          });
        case 5:
          _context.next = 11;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](2);
          logger.error(_context.t0, {
            offerId: params.offerId,
            domain: 'removeFavorite'
          });
          return _context.abrupt("return", false);
        case 11:
          return _context.abrupt("return", true);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 7]]);
  }));
  return _removeFavorites.apply(this, arguments);
}